"use client"

import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="top-right"
      className="toaster group"
      closeButton
      toastOptions={{
        classNames: {
          toast: "group toast bg-white text-slate-900 border-slate-200 shadow-lg",
          title: "text-sm font-medium",
          description: "text-sm text-slate-500",
          success: "!bg-green-50 !text-green-900 !border-green-200",
          warning: "!bg-amber-50 !text-amber-900 !border-amber-200",
          info: "!bg-blue-50 !text-blue-900 !border-blue-200",
          error: "!bg-error-50/95 !text-error-600 !border-error-200",
          // Above Sonner's close button (z-index 1); ensure clicks reach the button
          actionButton:
            "relative z-[2] pointer-events-auto cursor-pointer transition-opacity hover:opacity-90",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
